module.exports = __webpack_public_path__ + "img/efficency.8ba54ab3.png";